export function setState(state, [field, value]) {
  state[field] = value;
}

export function setApplication(state, application) {
  state.application = { ...application };
}
